
/* injects from baggage-loader */
require('./style.scss');

import React, { useState } from "react";
import { connect } from "react-redux";
import KeyboardInput from "../InputKeyboard";
import { t } from "../../../helpers/translator";
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import { cardDepositMode } from "../../../actions/terminal";
import Config from "../../../config/main";
const DepositMoney = (props) => {
    
    const [money, setMoney] = useState('');
    const handleChange = (value) => {
        const valMoney = /^[0-9]*\.?[0-9]*$/;
        
        if(valMoney.test(value)) {
            setMoney(value)
        }
    }
    return <div className='deposit-bank-card-container'>
        <p className='deposit-bank-card-title'>{t("Deposit by Bank card")}</p>
        <p className='deposit-bank-card-sub-title'>{t("Transfer from Bank account to terminal balance")}</p>
        <div className='money-input-container'>
            <p>{t("Deposite Amount")}</p>
            <KeyboardInput
                numeric
                customKeys={['.']}
                type='text'
                value={money}
                onChange={handleChange}
                setFocus= {true}
            />
            <p className='deposit-info'>{t(`In case of deposit by bank card, ${Config.main.cashoutCommissionPercent}% commission will be charged for cashing. You can transfer money to your account to avoid interest.`)}</p>
        </div>
        <div className='buttons-container'>
        <button
            className='button-view-normal-m cancel'
            onClick={() => props.dispatch(ClosePopup(true))}
        >
            {t('Cancel')}
        </button>
        <button
            className='button-view-normal-m'
            disabled={!money}
            onClick={() => {
                props.dispatch(cardDepositMode(money))
                props.dispatch(OpenPopup('depositMoneyPlaceCard'))
            }}
        >
            {t('Submit')}
        </button>
        </div>
    </div>
}
export default connect()(DepositMoney)